const isFileSizeUnderLimit = (file) => {
    if (file) 
    {
        return file.size <= 10485760;
    } 
      
    return true;
}
  
export default isFileSizeUnderLimit;